/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import { IOptionItemProps } from '../Select/Select';

export enum EReportScheduleField {
    Description = 'description',
    Month = 'month',
    Period = 'period',
    ReportType = 'reportType',
    StartTime = 'startTime',
    TimeHour = 'timeHour',
    TimeMinute = 'timeMinute',
    Week = 'week',
}

export interface IReportScheduleData {
    [EReportScheduleField.Description]?: string;
    [EReportScheduleField.Month]?: number;
    [EReportScheduleField.Period]?: Partial<IOptionItemProps>;
    [EReportScheduleField.StartTime]?: string;
    [EReportScheduleField.TimeHour]?: Partial<IOptionItemProps>;
    [EReportScheduleField.TimeMinute]?: Partial<IOptionItemProps>;
    [EReportScheduleField.Week]?: Partial<IOptionItemProps>;
}
